export const MEMBER_TYPES = {
  "Station chief": { np: "निर्देशकहरु", en: "Station chief" },
  Scientist: { np: "अन्वेषकहरू", en: "Scientist" },
  "Technical officer": {
    np: "बेलायतका अन्वेषक सल्लाहकारहरू",
    en: "Technical officer",
  },
  "Administrative officer": {
    np: "नेपालका सहयोगीहरू",
    en: "Administrative officer",
  },
  "Account officer": {
    np: "अन्तर्राष्ट्रिय सहयोगीहरू",
    en: "Account officer",
  },
  "Junior technician": {
    np: "अन्तर्राष्ट्रिय सहयोगीहरू",
    en: "Junior technician",
  },
  "Support staff": {
    np: "अन्तर्राष्ट्रिय सहयोगीहरू",
    en: "Support staff",
  },
};
